<template>
  <div class="otherOrder">
    <div class="container">
      <div class="titleNav">
        <router-link to="/courier/cityExpress">我要下单</router-link> /
        <router-link to="/courier/other">其他服务</router-link> /
        <router-link to="/courier/otherOrder">确认订单</router-link>
      </div>
      <div class="content">
        <div class="left">
          <img src="../../../assets/images/home/undraw_voice_control_ofo1.png" alt="">
          <p class="text">客服热线</p>
          <p class="tel">{{kfphone}}</p>
        </div>
        <div class="right">
          <table>
            <tr>
              <td>代办时间</td>
              <td><span>{{otherInfo.getGoodsDate }}</span></td>
            </tr>
            <tr>
              <td>联系人姓名</td>
              <td>{{otherInfo.name}}</td>
            </tr>
            <tr>
              <td>联系人电话</td>
              <td>{{otherInfo.mobile}}</td>
            </tr>
            <tr>
              <td>服务信息</td>
              <td>{{otherInfo.serviceContent}}</td>
            </tr>
            <tr>
              <td>备注信息</td>
              <td>
                {{otherInfo.description}}
              </td>
            </tr>
            <tr>
              <td>地址</td>
              <td>{{otherInfo.sendAddress}}{{otherInfo.sendAddressDetail}}</td>
            </tr>
            <tr>
              <td>应付酬劳</td>
              <td>客服 <span v-bind:ref>{{kfphone}}</span> ，拨打咨询 <span class="hint" @click="toHint">？</span></td>
            </tr>
            <tr>
              <td>应支付金额</td>
              <td>请拨打客服电话确定应付酬劳，确认后至个人中心的我的订单页面进行支付</td>
            </tr>

          </table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {formatDate} from '../../../utils/date'
import {systemSettingFindDetail} from '../../../api'
export default {
  data() {
    return {
      kfphone: "",
      otherInfo: {}
    }
  },
  created() {
    if(JSON.stringify(this.$store.state.otherInfo) === '{}'){
      this.$router.replace('/courier/other')
    }else{
      this.otherInfo = this.$store.state.otherInfo
    }

    // this.kfphone = "1231232"
    var that = this
    systemSettingFindDetail("servicePhoneSetting").then(res => {
      if(res.code === 200) {
        that.kfphone = res.data.bussData.svalue
      }
    })

  },
  methods: {
    // 去富文本提示页面
    toHint() {
      this.$router.push({name: 'RichText', query: {code: '005'}})
    },
  },
  filters: {
    format (time) {
      let date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  }
}
</script>

<style scoped lang="less" type="text/less">
.otherOrder{
  margin-bottom: 190px;
  .titleNav{
    margin:30px 0 41px;
  }
  .content{
    display: flex;
    justify-content: space-between;
    padding:30px 30px 60px 142px;
    box-shadow:0px 3px 9px 0px rgba(0, 0, 0, 0.09);
    .left{
      margin-top:47px;
      width: 225px;
      text-align: center;
      .text{
        margin-top:30px;
        font-size: 16px;
      }
      .tel{
        margin-top:11px;
        font-size: 24px;
        color:#2FA1DE;
      }
    }
    .right{
      table{
        td{
          border:1px solid #e1e1e1;
          line-height: 40px;
          &:first-of-type{
            width: 129px;
            text-indent: 20px;
          }
          &:last-of-type{
            width: 530px;
            padding-left:32px;
            box-sizing: border-box;
          }
          span{
            color:#61AEE6;
          }
          .hint{
            display: inline-block;
            width: 26px;
            height: 26px;
            margin:7px 10px;
            background: #61aee6;
            color: #ffffff;
            text-align: center;
            line-height: 26px;
            border-radius: 50%;
            font-weight: 700;
            font-size: 18px;
            cursor: pointer;
          }
        }
      }

    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/Courier/Other/OtherOrder.vue